/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsDiff = createReactComponent("arrows-diff", "IconArrowsDiff", [
  ["path", { d: "M11 16h10", key: "svg-0" }],
  ["path", { d: "M11 16l4 4", key: "svg-1" }],
  ["path", { d: "M11 16l4 -4", key: "svg-2" }],
  ["path", { d: "M13 8h-10", key: "svg-3" }],
  ["path", { d: "M13 8l-4 4", key: "svg-4" }],
  ["path", { d: "M13 8l-4 -4", key: "svg-5" }]
]);

export { IconArrowsDiff as default };
//# sourceMappingURL=IconArrowsDiff.js.map
